export default __webpack_public_path__ + "static/media/bariol_regular_italic-webfont.1ab57637.woff";